import * as React from 'react';

export const TokenContext = React.createContext<string>(undefined as any);

export function useApiToken() {
    return React.useContext(TokenContext);
}